import { ProductName, ProductType } from '@core/api';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore);
var isTrial = function isTrial(param) {
    var productName = param.productName, productType = param.productType;
    return productName === ProductName.COVEO_CLOUD && productType === ProductType.TRIAL;
};
var isTest = function isTest(param) {
    var productName = param.productName, productType = param.productType;
    return productName === ProductName.COVEO_CLOUD && productType === ProductType.TEST;
};
var isExpired = function isExpired(license) {
    var today = dayjs();
    return dayjs(license.expirationDate).isSameOrBefore(today);
};
var isTrialExpired = function isTrialExpired(license) {
    return LicenseHelper.isTrial(license) && isExpired(license);
};
var isTrialOrTestExpired = function isTrialOrTestExpired(license) {
    return (LicenseHelper.isTrial(license) || LicenseHelper.isTest(license)) && isExpired(license);
};
export var LicenseHelper = {
    /**
     * Determines whether the given license model is a trial.
     * @param license the LicenseModel
     * @returns `true` if the license is a trial, `false` otherwise.
     */ isTrial: isTrial,
    /**
     * Determines whether the given license model is a test.
     * @param license the LicenseModel
     * @returns `true` if the license is a test, `false` otherwise.
     */ isTest: isTest,
    /**
     * Determines whether the giver license model is an expired trial.
     * @param license the LicenseModel
     * @returns `true` if the license is an expired trial, `false` otherwise.
     */ isTrialExpired: isTrialExpired,
    /**
     * Determines whether the giver license model is an expired trial or test.
     * @param license the LicenseModel
     * @returns `true` if the license is an expired trial or test, `false` otherwise.
     */ isTrialOrTestExpired: isTrialOrTestExpired,
    /**
     * Determines whether the giver license model is expired.
     * @param license the LicenseModel
     * @returns `true` if the license is expired, `false` otherwise.
     */ isExpired: isExpired
};

//# sourceMappingURL=LicenseHelper.js.map